import React, { Component } from "react";
import Link from "gatsby-link";
import "./styles.scss";

class NavMobile extends Component {
    constructor() {
        super();

        this.state = {
            showMenu: false
        };

        this.showMenu = this.showMenu.bind(this);
        this.closeMenu = this.closeMenu.bind(this);
    }

    showMenu(event) {
        event.preventDefault();

        this.setState({ showMenu: true }, () => {
            document.addEventListener(`click`, this.closeMenu);
        });
    }

    closeMenu(event) {
        if (!this.dropdownMenu.contains(event.target)) {
            this.setState({ showMenu: false }, () => {
                document.removeEventListener(`click`, this.closeMenu);
            });
        }
    }

    render() {
        return (
            <div>
                <button onClick={this.showMenu} className="nav-mobile__button">
                    Menu{` `}
                    <img
                        className="nav-mobile__button-icon"
                        alt="Menu"
                        src="/images/icons/chevron-small-down.svg"
                    />
                </button>

                {this.state.showMenu ? (
                    <div
                        className="nav-mobile__nav-item"
                        ref={element => {
                            this.dropdownMenu = element;
                        }}
                    >
                        <div className="nav-mobile">
                            <div className="inner nav-mobile__inner">
                                <Link
                                    to="/"
                                    title="Home"
                                    className="nav-mobile__item"
                                >
                                    Home
                                </Link>
                                <Link
                                    to="/"
                                    title="Blog"
                                    className="nav-mobile__item"
                                >
                                    Blog
                                </Link>
                                <a
                                    href="https://invest.orcamoney.com/login"
                                    title="Schedule a call now"
                                    target="_blank"
                                    className="nav-mobile__item"
                                >
                                    Login
                                </a>
                                <a
                                    href="https://app.hubspot.com/meetings/iain7"
                                    title="Get in touch"
                                    className="nav-mobile__item"
                                    target="_blank"
                                >
                                    Get in touch
                                </a>
                            </div>
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }
}

export default NavMobile;
